





















import { computed, defineComponent } from '@vue/composition-api';
import { Component } from 'vue';
import { StepContentTypeEnum } from '@front-app/api-generated/learning-management-api';
import TrModal from '@front-app/components/modals/TrModal.vue';
import { useTranslate } from '@front-app/hooks/useTranslate';
import type { CompletedStepEvent } from './stepEvents';
import { getLearningProgramsStore } from '../store/LearningProgramsStore';
import SurveyStepVue from './SurveyStep.vue';
import VimeoStepVue from './VimeoStep.vue';
import YoutubeStepVue from './YoutubeStep.vue';

const COMPONENTS_BY_TYPE: Record<StepContentTypeEnum, Component> = {
	[StepContentTypeEnum.Survey]: SurveyStepVue,
	[StepContentTypeEnum.Youtube]: YoutubeStepVue,
	[StepContentTypeEnum.Vimeo]: VimeoStepVue,
};

const MODAL_TITLES: Record<StepContentTypeEnum, string> = {
	[StepContentTypeEnum.Survey]: 'lms.user.step-modal-title.survey',
	[StepContentTypeEnum.Youtube]: 'lms.user.step-modal-title.video',
	[StepContentTypeEnum.Vimeo]: 'lms.user.step-modal-title.video',
};

export default defineComponent({
	components: { TrModal },
	props: {
		stepId: {
			type: String,
			required: true,
		},
		isVisible: Boolean,
	},
	setup(props, ctx) {
		const programsStore = getLearningProgramsStore();
		const step = computed(() => programsStore.getStep(props.stepId));
		const currentStepComponent = computed(() => COMPONENTS_BY_TYPE[step.value.content.type]);
		const emitDone = (e: undefined | string) => {
			const event: CompletedStepEvent = {
				stepId: props.stepId,
				surveyResponse: e,
			};
			ctx.emit('done', event);
		};
		const $t = useTranslate(ctx);
		const accessibleTitle = computed(() => $t(MODAL_TITLES[step.value.content.type], step.value.name));

		return {
			step,
			accessibleTitle,
			currentStepComponent,
			emitDone,
		};
	},
});
